// extracted by mini-css-extract-plugin
export default {"container":"Skill_container__JxkZI","img":"Skill_img__7brmu","name":"Skill_name__XGd+I"};